import React from "react";
import NextImage from "next/image";
import { AspectRatio } from "@chakra-ui/react";

const BackgroundImage = () => (
  <>
    <AspectRatio
      ratio={430 / 123}
      position="absolute"
      top={0}
      zIndex={-3}
      w="100%"
      h={{ base: "384px", md: "574px" }}
      maxH="100%"
      display={["none", "block"]}
    >
      <NextImage
        priority
        quality={80}
        src="/img/scenes/Matterport/bg-matterport.png"
        alt=""
        blurDataURL="/img/scenes/Obsazko/bg_thumb.jpg"
        placeholder="blur"
        fill
        style={{
          filter: "brightness(0.5)",
          objectFit: "cover",
        }}
      />
    </AspectRatio>
    <AspectRatio
      ratio={430 / 123}
      position="absolute"
      top={0}
      zIndex={-3}
      w="100%"
      h="384px"
      maxH="100%"
      display={["block", "none"]}
    >
      <NextImage
        priority
        quality={80}
        src="/img/scenes/Matterport/bg-matterport.png"
        alt=""
        blurDataURL="/img/scenes/Obsazko/bg_mobile_thumb.jpg"
        placeholder="blur"
        fill
        style={{
          filter: "brightness(0.5)",
          objectFit: "cover",
        }}
      />
    </AspectRatio>
  </>
);

export default BackgroundImage;
